import { CategoryItem } from '../categories/category-item.model';

export class MembershipType
{
	constructor(json: any = null)
	{
		if (json)
		{
			// Map the json object to 'this' objects properties.
			Object.assign(this, json);

			// Custom mappings
			if (json.CategoryItems) this.CategoryItems = json.CategoryItems.map((item: any) => new CategoryItem(item));
		}
	}

	Id!: number;
	Name!: string;
	CanUploadMedia = false;
	CanDeleteMedia = false;
	UploadAlbumId?: number;
	CategoryItems: CategoryItem[] = [];
}
